export default __webpack_public_path__ + "static/products-bg-lg-84c1b89a798845c58fd0e68377a11361.png";